import { OverviewAppSyncClient } from "../clients/OverviewAppSyncClient";
import { OverviewService } from "./OverviewService";
import { OverviewHttpClient } from "../clients/OverviewHttpClient";
import { oktaAuth } from "../config/OktaConfig";

export const overviewService = new OverviewService(
    new OverviewAppSyncClient(oktaAuth),
    new OverviewHttpClient(oktaAuth),
);
